import AjaxDataSend from '../../elements/shopEcp/ajaxDataSend.js';
const init = () => {
    let targetElement = document.querySelector(".js-white-paper-thank-you");
    if(!targetElement){
        return;
    }
    let params = new URLSearchParams(document.location.search);
    let linkToDownload = params.get("linkToDownload");
    if(linkToDownload){
        let formData = {};
        formData.whitePaperLink = linkToDownload;
        AjaxDataSend({
            url: '/ajax/file-link-validation/', data: formData,
            onSuccess: function(response) {
                targetElement.href = response.linkToDownload;
            },
            onError: function(response) {},
            onComplete: function(response) {},
            beforeSend: function() {},
        });
    }
}
window.addEventListener("DOMContentLoaded", init, false);
